import React, { useState } from 'react'

import { BaseCard as Card } from 'components/CardLayout'
import { LineChart, ScatterChart, BarChart } from 'components/Charts'

import './style.scss'

const classes = {
  wrapper: 'ChartsPage-wrapper',
  tabDiv: 'ChartsPage-tabDiv',
  tabButton: 'ChartsPage-tabButton',
}

const TrainingCharts = props => {
  const [state, setState] = useState('line')

  return (
    <div className={classes.wrapper}>
      <div className={classes.tabDiv}>
        <button
          className={classes.tabButton}
          type="button"
          data-active={state === 'line'}
          onClick={event => {
            event.preventDefault()
            setState('line')
          }}
        >
          Line Chart
        </button>
        <button
          className={classes.tabButton}
          type="button"
          data-active={state === 'scatter'}
          onClick={event => {
            event.preventDefault()
            setState('scatter')
          }}
        >
          Scatter Chart
        </button>
        <button
          className={`${classes.tabButton}`}
          type="button"
          data-active={state === 'bar'}
          onClick={event => {
            event.preventDefault()
            setState('bar')
          }}
        >
          Bar Chart
        </button>
      </div>
      <Card style={{ visibility: state === 'line' ? 'visible' : 'hidden' }}>
        <LineChart
          controlable={{
            trainings: { multiple: true },
            brains: { multiple: true },
            features: { multiple: true },
            split: true,
            type: true,
          }}
          legend={{ position: 'right', width: 300 }}
          xAxis
          yAxis
          grid
          mainColor="#1E90FF"
        />
      </Card>
      <Card style={{ visibility: state === 'scatter' ? 'visible' : 'hidden' }}>
        <ScatterChart
          controlable={{
            trainings: { multiple: true },
            brains: { multiple: true },
            split: true,
            x: { multiple: true },
            y: { multiple: true },
            z: true,
          }}
          legend={{ position: 'right', width: 300 }}
          xAxis
          yAxis
          grid
          mainColor="#1E90FF"
        />
      </Card>
      <Card style={{ visibility: state === 'bar' ? 'visible' : 'hidden' }}>
        <BarChart
          controlable={{
            trainings: { multiple: true },
            brains: { multiple: true },
            features: { multiple: true },
            split: true,
          }}
          xAxis
          yAxis
          grid
          mainColor="#1E90FF"
        />
      </Card>
    </div>
  )
}

export default TrainingCharts
